import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Layout from "@/components/site/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Speakers from "@/pages/Speakers";
import Agenda from "@/pages/Agenda";
import Register from "@/pages/Register";
import Contact from "@/pages/Contact";
import Poznajmy from "@/pages/Poznajmy";
import Sponsorzy from "@/pages/Sponsorzy";
import Wspolpraca from "@/pages/Wspolpraca";
import Polityka from "@/pages/Polityka";
import Regulamin from "@/pages/Regulamin";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/o-kongresie" element={<About />} />
            <Route path="/prelegentki" element={<Speakers />} />
            <Route path="/agenda" element={<Agenda />} />
            <Route path="/zapisz-sie" element={<Register />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/poznajmy-sie" element={<Poznajmy />} />
            <Route path="/sponsorzy" element={<Sponsorzy />} />
            <Route path="/wspolpraca" element={<Wspolpraca />} />
            <Route path="/polityka-prywatnosci" element={<Polityka />} />
            <Route path="/regulamin" element={<Regulamin />} />
            <Route path="*" element={<NotFound />} />
          </Route>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#FFFFFF",
            color: "#2B2623",
            border: "1px solid #E8E1D9",
            borderRadius: "12px",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
